// src/hooks/useUniversitySettings.js
// 大学ごとの設定（学籍番号の形・取り込み方法の ON/OFF）を読む【2026-11-04】
//   GET /api/university-settings。ログインしている人（トークン）ごとに1回だけ取りに行き、画面どうしで使い回す。
//   読めないとき（v85 未適用・通信できない・学生）は「全部使える」として動く（サーバーの入口でも止めているので、画面は今までどおりでよい）。
import { useEffect, useState } from 'react';

const token = () => { try { return localStorage.getItem('token') || ''; } catch (e) { return ''; } };

let cache = null;     // { token, data }
let pending = null;   // { token, promise }
const listeners = new Set();

function fetchSettings(force = false) {
  const t = token();
  if (!force && cache && cache.token === t) return Promise.resolve(cache.data);
  if (!force && pending && pending.token === t) return pending.promise;
  const promise = fetch('/api/university-settings', { headers: { Authorization: 'Bearer ' + t } })
    .then(r => r.json())
    .then(d => (d && d.success ? d : null))
    .catch(() => null)
    .then(data => { cache = { token: t, data }; pending = null; listeners.forEach(fn => fn(data)); return data; });
  pending = { token: t, promise };
  return promise;
}

/** 保存したあとに呼ぶ（ほかの画面の表示もそろう） */
export function setUniversitySettings(data) {
  cache = { token: token(), data };
  listeners.forEach(fn => fn(data));
}

export function useUniversitySettings() {
  const [data, setData] = useState(() => (cache && cache.token === token() ? cache.data : undefined));
  useEffect(() => {
    let alive = true;
    const fn = (d) => { if (alive) setData(d); };
    listeners.add(fn);
    fetchSettings().then(fn);
    return () => { alive = false; listeners.delete(fn); };
  }, []);
  return data;   // undefined = 読み込み中、null = 読めない
}

/** 取り込み方法が使えるか。読み込み中・読めないときは true */
export function useImportSources() {
  const data = useUniversitySettings();
  const list = (data && data.importSources) || [];
  return {
    loaded: data !== undefined,
    on: (code) => { const s = list.find(x => x.code === code); return s ? s.enabled !== false : true; },
  };
}
